import React from 'react';
import styled from 'styled-components';
import Dnaicon from '../../Image/DNAicon.png';
import Insuranceicon from '../../Image/Insuranceicon.png';
import Medicalicon from '../../Image/Medicalicon.png';
import Labicon from '../../Image/Labicon.png';
import Cleanicon from '../../Image/Cleanicon.png';
import Trainingicon from '../../Image/Routeicon.png';

const informationData = [
    {
        id: 1,
        title: 'DNA Diagnostics',
        icon: Dnaicon,
        description: 'We are proud to announce that we provide high-quality diagnostics for DNA.',
    },
    {
        id: 2,
        title: 'Insurance',
        icon: Insuranceicon,
        description: 'You can get our insurance to not care about any financial difficulties in the future.',
    },
    {
        id: 3,
        title: 'Medical Support',
        icon: Medicalicon,
        description: 'We have a huge amount of high-quality medicine from Germany.',
    },
    {
        id: 4,
        title: 'Lab Achievements',
        icon: Labicon,
        description: 'iMedical has 12 laboratory achievements that have a world-level impact in medicine.',
    },
    {
        id: 5,
        title: '24/7 Clean',
        icon: Cleanicon,
        description: 'We care about having clean and safe rooms for our patients.',
    },
    {
        id: 6,
        title: 'Training Routine',
        icon: Trainingicon,
        description: 'Our doctors will help you get a personal training routine to achieve the best results.',
    },
];

const Information = () => {
    return (
        <MainInformation>
            <Heading>Why Us?</Heading>
            <CardContainer>
                {informationData.map(info => (
                    <InfoCard key={info.id}>
                        <CardIcon src={info.icon} alt={info.title} />
                        <CardHeading>{info.title}</CardHeading>
                        <CardParagraph>{info.description}</CardParagraph>
                    </InfoCard>
                ))}
            </CardContainer>
        </MainInformation>
    );
};

export default Information;

const MainInformation = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const Heading = styled.h1`
    font-family: Poppins;
    font-size: 48px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        font-size: 36px;
    }
`;

const CardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    width: 100%;
    margin: 5%;
`;

const InfoCard = styled.div`
    width: 20%; /* Adjusted width for large screens, you can tweak this value */
    border-radius: 30px;
    padding: 20px;
    margin: 0 2% 20px 2%; /* Adjusted margin for better spacing */
    cursor: pointer;
    transition: background 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

    &:nth-child(3n+1) {
        margin-left: 0; /* Clear margin for the first card in each row */
    }

    &:nth-child(3n) {
        margin-right: 0; /* Clear margin for the last card in each row */
    }

    &:hover {
        background: white;
        box-shadow: 0px 34px 71px -4px #0F97B524;
    }

    @media (max-width: 860px) {
        width: 40%; /* Adjusted width for medium screens, you can tweak this value */
    }

    @media (max-width: 560px) {
        width: 80%; /* Adjusted width for medium screens, you can tweak this value */
    }

    @media (max-width: 408px) {
        width: 90%; /* Full width for small screens */
        margin: 0; /* Remove margin on small screens */
    }
`;


const CardIcon = styled.img`
    width: 100px;
    height: 100px;
    radius: 150px;
`;

const CardHeading = styled.h3`
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 10px;
    color: black;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

const CardParagraph = styled.p`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 10px;
    color: black;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;
